import { baseApi, QueryTag } from 'shared/api';
import { Routes } from 'shared/routes';

export const logoutApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    logout: builder.mutation<void, void>({
      query: () => ({
        url: Routes.backend.apiV1SessionsPath(),
        method: 'DELETE',
      }),
      invalidatesTags: [QueryTag.CurrentUser],
    }),
  }),
});

export const { useLogoutMutation } = logoutApi;
